import React from 'react';
import PropTypes from 'prop-types';

import {Box, Stack, Typography} from 'views/components';

import CaseCard from '../card/CaseCard';

const KanbanColumn = (props) => {
  const {
    cases,
    title,
  } = props;

  return (
    <Stack
      sx={{
        flex: '1 0 280px',
        minWidth: 280,
        backgroundColor: '#F8F6F3',
        border: '1px solid #E8E4DE',
        borderRadius: '8px',
      }}
    >
      <Box
        sx={{
          px: 2,
          py: 1.5,
          borderBottom: '1px solid #E8E4DE',
        }}
      >
        <Typography
          sx={{
            fontSize: '13px',
            fontWeight: 600,
            color: '#1A1916',
            textTransform: 'uppercase',
          }}
        >
          {title}
        </Typography>
      </Box>
      <Stack
        sx={{
          gap: 1.5,
          p: 1.5,
        }}
      >
        {
          cases.map((caseData) => (
            <CaseCard
              key={caseData.caseRn}
              caseData={caseData}
            />
          ))
        }
      </Stack>
    </Stack>
  );
};

KanbanColumn.propTypes = {
  cases: PropTypes.array.isRequired,
  title: PropTypes.string.isRequired,
};

export default React.memo(KanbanColumn);
